import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListLocais from '../../components/locais/esporte';


function ListEsporteScreen() {
    return (
        <Fragment>
            <Head titulo="Quadras e Centros Esportivos em Macuco" />
            <Header />
            <Container>
               <ListLocais /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListEsporteScreen;